import { ratingFilterList, replyFilterList } from 'Services/reviewFilterList'

/**
 * @param {number[]} ratingList
 * @returns {number[]}
 */
const formatRatingList = (ratingList) => {
  return ratingFilterList
    .filter(item => ratingList.includes(item.id))
    .map(item => item.value)
}

/**
 * @param {number[]} replyList
 * @returns {boolean}
 */
const formatReply = (replyList) => {
  const [ firstFilterId = 0 ] = replyList
  const { value = false } = replyFilterList.find(filter => filter.id === firstFilterId)

  return value
}

/**
 * @param {string} searchTerm
 * @param {object} filters
 * @param {number[]} filters.ratings
 * @param {number[]} filters.replies
 * @returns {ReviewCompanyOptions}
 */
export const formatReviewFilter = (searchTerm, filters) => {
  const { ratings: ratingList, replies: replyList } = filters

  return {
    filter: searchTerm !== ''
      ? searchTerm
      : null,

    rating: ratingList.length > 0
      ? formatRatingList(ratingList)
      : null,

    withReply: replyList.length === 1
      ? formatReply(replyList)
      : null
  }
}

export default {
  formatReviewFilter
}